import angular from 'angular';

module.exports = angular.module('market.models.agent-referral', [])
.factory('AgentReferral', function(odResource) {
  return odResource('/api/v1/agent-referrals');
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/agent-referral.js
 **/